/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class PractitionerApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `PractitionerModule.forRoot()`
 */
export interface PractitionerApiConfigurationParams {
  rootUrl?: string;
}
